// extracted by mini-css-extract-plugin
export default {"label":"Filter_label__CLSp2","input":"Filter_input__S09D5"};